import { render, staticRenderFns } from "./LeaveBreakdown.vue?vue&type=template&id=c2f196fc"
import script from "./LeaveBreakdown.vue?vue&type=script&lang=js"
export * from "./LeaveBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports